@switch (formType()) {
  @case (accPatientFormType.AccPatientDetailsForm) {
    <pr-acc-patient-form [form]="patientForm" />
  }
  @case (accPatientFormType.AccAccidentDetailsForm) {
    <pr-acc-injury-form [form]="injuryForm" />
  }
  @default {
    <pr-acc-employment-form [form]="employmentForm" />
  }
}
